import React from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../../../constants/ApplicationUrl";
import {
  SUPPORTING_DOCUMENTS,
  headerSortingStyle,
} from "../../../../constants";
import { ROLES } from "../../../../constants/Roles";
import { storage } from "../../../../dependencies/store/storage";
import moment from "moment";
import { FaTrash } from 'react-icons/fa';

export const rowStyle2 = (row, rowIndex) => {
  const style = {};
  if (row.nonProfitCompany) {
    style.backgroundColor = "#a3ca57";
  } else if (row.isEdited) {
    style.backgroundColor = "#bffedf";
  } else if (row.natureOfEntity === "Registered Partnership") {
    style.backgroundColor = "#ffdb99";
  }

  return style;
};

const columns = ({ handleEditClick, clickOnAction, pageNo, size }) => {
  const userRole = storage.getUserRole();

  const recognitionDateFormatter = (cell) => {
    return moment(cell).format("YYYY-MM-DD");
  };

  const resultNsaFormatter = (cell, row) => {
    if (Array.isArray(cell)) {
      const tooltipText = cell.map(item => item.eventId).join(', '); 
      return (
        <span title={tooltipText}>
          {cell.map((item, index) => (
            <span key={index}>
              {item.eventId}
              {index !== cell.length - 1 && ", "}
            </span>
          ))}
        </span>
      );
    }
  
    return cell;
  };

  const resultNsaFormattedCorporateNames = (cell, row) => {
    if (Array.isArray(cell)) {
      const corporateNames = cell.flatMap(item => item.corporateName || []);
      const tooltipText = corporateNames.join(', ');
  
      return (
        <span title={tooltipText}>
          {corporateNames.map((name, index) => (
            <span key={index}>
              {name}
              {index !== corporateNames.length - 1 && ", "}
            </span>
          ))}
        </span>
      );
    }
  
    return cell;
  };
  
  

  const resultNsaFormatteEventName = (cell, row) => {
    if (Array.isArray(cell)) {
      const tooltipText = cell.map(item => item.eventName).join(', '); 
      return (
        <span title={tooltipText}>
          {cell.map((item, index) => (
            <span key={index}>
              {item.eventName}
              {index !== cell.length - 1 && ", "}
            </span>
          ))}
        </span>
      );
    }
  
    return cell;
  };

  const resultNsaFormatteYear = (cell, row) => {
    console.log("hostedCountry cell:", cell); 
    if (Array.isArray(cell)) {
      return cell.map((item, index) => (
        <span key={index}>
          {item.yearOfEngagement}
          {index !== cell.length - 1 && ", "}
        </span>
      ));
    }
  
    return cell;
  };
  

  return [
    {
      dataField: "",
      text: "S.No",
      formatter: (cell, row, rowIndex) => {
        return pageNo * size + (rowIndex + 1);
      },
    },
    {
      dataField: "certificateNumber",
      text: "Recognition No",
      sort: false,
    },
    {
      dataField: "recognitionDate",
      text: "Recognition Date",
      formatter : recognitionDateFormatter
    },
    {
      dataField: "corporateTags.corporateTags",
      text: "Event ID",
      formatter: resultNsaFormatter
    },
    
    {
      dataField: "corporateTags.corporateTags",
      text: 'Corporate Name',
      formatter :resultNsaFormattedCorporateNames
    },
    {
      dataField: "corporateTags.corporateTags",
      text: "Program Name",
      formatter :resultNsaFormatteEventName
    },
    {
      dataField: "corporateTags.corporateTags",
      text: "Year of Engagement",
      formatter: resultNsaFormatteYear,
    },
    {
      dataField: "industry",
      text: "Industry",
      // formatter: resultNsaFormatteYear,
    },
    {
      dataField: "section",
      text: "Sector",
      // formatter: resultNsaFormatteYear,
    },
    {
      dataField: "nameOfEntity",
      text: "Name of Entity",
    },
    {
      dataField: "emailId",
      text: "Email",
    },
    {
      dataField: "mobileNumber",
      text: "Phone No.",
    },
    ...(userRole === ROLES.SUPER_ADMIN
      ? [
        {
          dataField: 'Edit action',
          text: 'Action',
          formatter: (cell, row) => {
            return (

              <div style={{ cursor: "pointer" }}>
              {console.log("row",row)}
                <FaTrash onClick={() => handleEditClick(row)} className="edit-button" />
              </div>
            );
          },
        },
      ]
      : []),

  ];
};

export default columns;
